/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeCompanies.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Company Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:18 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const COMPANY_LIST_CONTAINER_LOADED = 'COMPANY_LIST_CONTAINER_LOADED';
export const COMPANY_LIST_CONTAINER_UNLOADED = 'COMPANY_LIST_CONTAINER_UNLOADED';
export const COMPANY_LIST_TABLE_LOADED = 'COMPANY_LIST_TABLE_LOADED';
export const COMPANY_LIST_TABLE_UNLOADED = 'COMPANY_LIST_TABLE_UNLOADED';
export const COMPANY_LIST_CHANGE_STATUS = 'COMPANY_LIST_CHANGE_STATUS';
export const COMPANY_SELECT_ROW = 'COMPANY_SELECT_ROW';
export const COMPANY_ADD = 'COMPANY_ADD';
export const COMPANY_EDIT = 'COMPANY_EDIT';
export const COMPANY_DELETE = 'COMPANY_DELETE';
export const COMPANY_DELETE_DISABLE = 'COMPANY_DELETE_DISABLE';
export const COMPANY_OPEN_WARNING = 'COMPANY_OPEN_WARNING';
export const COMPANY_CLOSE_WARNING = 'COMPANY_CLOSE_WARNING';

export const COMPANY_EDIT_CONTAINER_LOADED = 'COMPANY_EDIT_CONTAINER_LOADED';
export const COMPANY_EDIT_CONTAINER_UNLOADED = 'COMPANY_EDIT_CONTAINER_UNLOADED';
export const COMPANY_EDIT_FORM_LOADED = 'COMPANY_EDIT_FORM_LOADED';
export const COMPANY_EDIT_FORM_UNLOADED = 'COMPANY_EDIT_FORM_UNLOADED';
export const COMPANY_EDIT_DATA_LOAD = 'COMPANY_EDIT_DATA_LOAD';
export const COMPANY_EDIT_CONTAINER_SUBMIT = 'COMPANY_EDIT_CONTAINER_SUBMIT';
export const COMPANY_EDIT_CONTAINER_CANCEL = 'COMPANY_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeCompanies.js